const cardFooterStyle = {
  cardFooter: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "transparent",
    padding: "1rem 1.875rem"
  }
};

export default cardFooterStyle;
